import { useState } from "react";
import { subscribe } from "../../../utils/API/subscribe";
import toast from "react-hot-toast";


const Subscribe = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
 

  const handleSubscribe = async () => {
    if (!email) {
      setError("Email is required");
      toast.error("Email is required");
      return;
    }

    setLoading(true);
    setError(null);
    
    try {
      const response = await subscribe({ email });
      toast.success("Subscription successful");
      // console.log('Subscription successful:', response);
    } catch (err) {
      
      const errorMessage =  err.message || "Subscription failed. Please try again.";
      setError(errorMessage);
      toast.error(errorMessage);
      console.error('Error subscribing:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex">
      <input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        className="w-96 h-10 bg-[#d9d9d942] text-black focus-none p-4 rounded-[10px_0px_0px_10px]"
        placeholder="Email"
      />
      <button
        onClick={handleSubscribe}
        className="w-48 h-10 bg-[#4361EE] text-white rounded-[0px_10px_10px_0px]"
        disabled={loading}
      >
        {loading ? "Subscribing..." : "Subscribe"}
      </button>
      {error && <div className="text-red-500 ml-2">{error}</div>} 
    </div>
  );
};

export default Subscribe;
